module.exports = __webpack_public_path__ + "static/media/8d6fed74.jpg";